var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "console-wrap" },
    [
      _c("div", { class: { "console-header": true, nbd: _vm.isConsoleHome } }, [
        _c("div", { staticClass: "con-box" }, [
          _c(
            "div",
            { staticClass: "account", staticStyle: { display: "flex" } },
            [
              _c("div", { staticClass: "flex-b nw" }, [
                _c("img", {
                  staticClass: "photo",
                  attrs: {
                    src:
                      _vm.currentAuthUser.imgPath && !_vm.isInDingTalk
                        ? _vm.fileOperShow(_vm.currentAuthUser.imgPath)
                        : "",
                    onerror: "this.src='/images/web/login_user_icon.png'"
                  }
                }),
                _c("div", { staticClass: "moreInfo" }, [
                  _vm.currentAuthUser.userStemFrom === -16 && !_vm.isInDingTalk
                    ? _c("img", {
                        staticStyle: {
                          width: "20px",
                          height: "20px",
                          "margin-right": "5px"
                        },
                        attrs: { src: "/images/icon/dingIcon.png", alt: "" }
                      })
                    : _vm._e(),
                  _c("span", { staticClass: "name" }, [
                    _vm._v(_vm._s(_vm.corpName))
                  ])
                ]),
                !_vm.isInDingTalk
                  ? _c("i", {
                      staticClass: "el-icon-caret-bottom",
                      staticStyle: { "font-size": "24px" }
                    })
                  : _vm._e()
              ]),
              !_vm.isInDingTalk
                ? _c(
                    "div",
                    { staticClass: "comp-expand" },
                    [
                      _c("change-account", {
                        attrs: {
                          users: _vm.consoleUsers,
                          ywtAccountChoose: true
                        },
                        on: { showExpandIcon: _vm.showExpandIcon }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "flex-end" } },
            [
              _c(
                "ul",
                _vm._l(_vm.endConsoleMenus, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      class: { active: _vm.getMenu(item) },
                      attrs: { id: "menu" + index },
                      on: {
                        click: function($event) {
                          return _vm.toMenusItem(item)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(item.name))])]
                  )
                }),
                0
              ),
              _c(
                "div",
                { staticClass: "ls-sh" },
                [
                  _c(
                    "el-button",
                    { staticClass: "backBZ", on: { click: _vm.turnBack } },
                    [_vm._v("返回首页")]
                  )
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm.isConsoleHome
        ? [_c("nuxt")]
        : _c(
            "el-container",
            {
              staticStyle: { "overflow-x": "auto", "margin-bottom": "20px" },
              style: { "min-height": "100%" }
            },
            [
              _c(
                "div",
                { staticClass: "main" },
                [
                  _vm.isRouterAlive
                    ? _c(
                        "el-main",
                        [_c("div", { staticClass: "bread" }), _c("nuxt")],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
      _c("suspend"),
      _c("my-footer")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-309e42ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-309e42ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/entconsolelayout.vue
// module id = UITU
// module chunks = 72